
import { aboutImages } from '../../../utils/images';

export default function OurCapabilitiesSection() {
  const capabilities = [
    {
      title: "Leather Development",
      description: "From the roots of tanning and dyeing, we specialize in high-quality products such as sheepskin, lambskin, and cowhide, with advanced finishes including printing, washing, and coating.",
      icon: "ri-shirt-line",
      image: aboutImages.capabilities.leatherDevelopment,
    },
    {
      title: "Material Innovation",
      description: "Custom leather, shearling, and faux fur development aligned with seasonal trends and sustainability goals.",
      icon: "ri-lightbulb-line",
      image: aboutImages.capabilities.materialInnovation,
    },
    {
      title: "Flexible Production",
      description: "Small-batch prototyping to large-scale manufacturing with fast response to market needs.",
      icon: "ri-settings-3-line",
      image: aboutImages.capabilities.flexibleProduction,
    },
    {
      title: "Global Support",
      description: "FOB & LDP terms, customs compliance, and logistics expertise for US and EU markets.",
      icon: "ri-global-line",
      image: aboutImages.capabilities.globalSupport,
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="text-gray-600 text-sm font-light tracking-[0.2em] uppercase mb-6">
            What We Do Best
          </div>
          <h2 className="text-5xl lg:text-6xl font-light mb-8 leading-tight">
            Our{' '}
            <span className="font-normal">
              Capabilities
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          {capabilities.map((capability, index) => (
            <div key={index} className="group">
              <div className="mb-4">
                <img
                  src={capability.image}
                  alt={capability.title}
                  className="w-full h-64 object-cover object-top"
                />
              </div>
              <div className="mt-2">
                <h3 className="text-2xl font-medium mb-2">{capability.title}</h3>
                <p className="text-gray-700 leading-relaxed">
                  {capability.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
